import { BannerItem } from "@hermes/api-model-shell";

export const isBannerItemsNotEmpty = (
    bannerItems: BannerItem[] | undefined,
): boolean => !!(bannerItems && bannerItems.length > 0);
